import React from 'react';
import { Box } from '@mui/material';
import styles from './styles';

const Container = ({ children, fillHeight = false, style, sx, ...props }) => (
  <Box
    {...props}
    sx={{
      ...styles.container,
      ...(fillHeight ? styles.fillHeight : {}),
      ...sx,
    }}
    style={{
      ...style,
    }}
  >
    {children}
  </Box>
);

export default Container;
